// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__DgYFA","consentsList":"PatientConsents_consentsList__K6ThE","consentsListEmpty":"PatientConsents_consentsListEmpty__3GEDP"};